module.exports = "<div class='delta'\r\n     ng-class=\"{\r\n       'delta-percentage-positive': $ctrl.delta > 0,\r\n       'delta-percentage-negative': $ctrl.delta < 0,\r\n       'delta-small': $ctrl.size === 'small',\r\n      }\">\r\n  <span ng-if='$ctrl.deltaAsPerc'>\r\n     {{ $ctrl.delta | number:2 }}%\r\n  </span>\r\n  <rw-currency ng-if='!$ctrl.deltaAsPerc'\r\n               value='$ctrl.delta'>\r\n  </rw-currency>\r\n</div>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/modules/utils/rw-trend-indicator/rw-trend-indicator.html
// module id = 2091
// module chunks = 0